import { axiosRequest } from "../../configs/axios.config";

export class ListService {
  getById(idList, success, error) {
    axiosRequest.get(`/lists/${idList}`)
      .then(({ data }) => success(data))
      .catch(errorResp => error(errorResp))
  }

  update(idList, data, success, error) {
    axiosRequest.put(`/lists/${idList}`, data)
      .then(({ data }) => success(data))
      .catch(errorResp => error(errorResp))
  }

  createRule(idList, data, success, error) {
    axiosRequest
      .post(`/lists/${idList}/create_rule`, data)
      .then(({data}) => success(data))
      .catch(err => error(err))
  }

  fetchRules(idList, success, error) {
    axiosRequest
      .get(`/lists/${idList}/rules`)
      .then(({data}) => success(data))
      .catch(err => error(err))
  }

  syncDefaults(success, error) {
    axiosRequest
      .post(`/lists/sync_defaults`)
      .then(({data}) => success(data))
      .catch(err => error(err))
  }
}